import { createContext, useContext, useEffect, useState } from 'react';
import { fetchDeletedProductIds } from '../lib/firebase';

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    let isActive = true;

    const restoreWishlist = async () => {
      const savedWishlist = JSON.parse(localStorage.getItem('wishlist') || '[]') || [];
      let deletedProductIds = new Set();

      try {
        deletedProductIds = new Set(await fetchDeletedProductIds());
      } catch (error) {
        console.warn('Could not check deleted products in wishlist:', error);
      }

      if (isActive) {
        setWishlist(savedWishlist.filter((item) => !deletedProductIds.has(item?.id)));
      }
    };

    restoreWishlist();

    return () => {
      isActive = false;
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  const addToWishlist = (product) => {
    setWishlist((current) => {
      if (current.some((item) => item.id === product.id)) {
        return current;
      }

      return [...current, product];
    });
  };

  const removeFromWishlist = (productId) => {
    setWishlist((current) => current.filter((item) => item.id !== productId));
  };

  const isInWishlist = (productId) => wishlist.some((item) => item.id === productId);

  const toggleWishlist = (product) => {
    if (wishlist.some((item) => item.id === product.id)) {
      removeFromWishlist(product.id);
      return false;
    }

    addToWishlist(product);
    return true;
  };

  const value = {
    wishlist,
    addToWishlist,
    removeFromWishlist,
    toggleWishlist,
    isInWishlist,
    wishlistCount: wishlist.length,
  };

  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}

export const useWishlist = () => useContext(WishlistContext);
